module.exports = __webpack_public_path__ + "static/Resume-Logan-Besecker-7c0e54d4a19bb899ef149ae8162df02f.pdf";